import { styled } from '@mui/material/styles';
import { Box, Dialog, Typography } from '@mui/material';

// Must sit above sticky headers (1100), bottom nav (1000), and carousel controls (99999).
export const ACCOUNT_QR_MODAL_Z_INDEX = 100000;

export const StyledDialog = styled(Dialog)({
  zIndex: ACCOUNT_QR_MODAL_Z_INDEX,
  '& .MuiBackdrop-root': {
    touchAction: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
  '& .MuiDialog-paper': {
    borderRadius: 24,
    overflow: 'hidden',
    maxWidth: 360,
    width: 'calc(100% - 32px)',
    pointerEvents: 'auto',
  },
});

export const ModalHeader = styled(Box)`
  padding: 24px 24px 0;
  text-align: center;
`;

export const ModalTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 600;
  color: #24203a;
`;

export const ModalSubtitle = styled(Typography)`
  margin-top: 8px;
  font-size: 14px;
  color: #64748b;
`;

export const QrContainer = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 24px;
`;

export const QrFrame = styled(Box)`
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
`;

export const ModalActions = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 24px 24px;
`;
